import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  FiltroParametrizacionDTO,
  IModificarParametroRequest,
  ParametrizacionDto,
  RespuestaParametrizacionDTO,
} from '../dto/expediente/parametrizacion.dto';

@Injectable({
  providedIn: 'root',
})
export class ParametrizacionService {
  constructor(private http: HttpClient) {}
  private apiUrl = `${environment.apiUrl}/lista/parametrizacion`;

  getUrlParametrizacion(
    filtro: FiltroParametrizacionDTO
  ): Observable<RespuestaParametrizacionDTO> {
    return this.http.post<RespuestaParametrizacionDTO>(this.apiUrl, filtro);
  }

  modificarParametrizacion(
    parametroId: number,
    role: string,
    data: IModificarParametroRequest
  ): Observable<ParametrizacionDto> {
    const requestData = {
      ...data,
      role: role,
    };
    return this.http.patch<ParametrizacionDto>(
      `${this.apiUrl}/${parametroId}`,
      requestData
    );
  }

  obtenerParametrizacionUrlPqrs(): Observable<ParametrizacionDto> {
    return this.http.get<ParametrizacionDto>(`${this.apiUrl}/url-pqrs`);
  }
  obtenerParametroPorNombre(nombre: string): Observable<ParametrizacionDto> {
    return this.http.get<ParametrizacionDto>(`${this.apiUrl}/${nombre}`);
  }
  obtenerParametrizacionUrlCms(): Observable<ParametrizacionDto> {
    return this.http.get<ParametrizacionDto>(`${this.apiUrl}/url-cms`);
  }
}
